var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoliveCam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2187 3.85625C12.9625 3.71875 12.425 3.575 11.6937 4.0875L10.775 4.7375C10.7062 2.79375 9.8625 2.03125 7.8125 2.03125H4.0625C1.925 2.03125 1.09375 2.8625 1.09375 5V10C1.09375 11.4375 1.875 12.9688 4.0625 12.9688H7.8125C9.8625 12.9688 10.7062 12.2062 10.775 10.2625L11.6937 10.9125C12.0812 11.1875 12.4187 11.275 12.6875 11.275C12.9187 11.275 13.1 11.2062 13.2187 11.1437C13.475 11.0125 13.9062 10.6562 13.9062 9.7625V5.2375C13.9062 4.34375 13.475 3.9875 13.2187 3.85625ZM6.875 7.1125C6.23125 7.1125 5.7 6.5875 5.7 5.9375C5.7 5.2875 6.23125 4.7625 6.875 4.7625C7.51875 4.7625 8.05 5.2875 8.05 5.9375C8.05 6.5875 7.51875 7.1125 6.875 7.1125Z",
    fill: "#F9E9EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoliveCam);
export default __webpack_public_path__ + "static/media/golive-cam.2431199c5f149b18143be6e2c2123b04.svg";
export { ForwardRef as ReactComponent };